import {
    Inbox,
    AlertTriangle,
    RussianRuble,
    Gauge,
    Droplet,
    ArrowUpDown,
    Flame,
    Zap,
    Wrench,
    Brush,
    CheckCircle2,
    Send,
    Vote,
} from "lucide-react";
import type {
    HomeStat,
    PriorityTicket,
    CollectionsData,
    TopBuilding,
    ActivityEvent,
    ActiveVote,
} from "./types.ts";

export const HOME_STATS: HomeStat[] = [
    {
        id: "tickets",
        icon: Inbox,
        accent: "emerald",
        label: "Открытые заявки",
        value: "148",
        delta: "+12%",
        deltaDir: "up",
        sub: "за сегодня 24 новых",
    },
    {
        id: "alerts",
        icon: AlertTriangle,
        accent: "danger",
        label: "Аварии и SLA-риски",
        value: "6",
        delta: "−2",
        deltaDir: "down",
        sub: "2 просрочены > 24 ч",
    },
    {
        id: "collection",
        icon: RussianRuble,
        accent: "info",
        label: "Собираемость, май",
        value: "91.4%",
        delta: "+1.8 пп",
        deltaDir: "up",
        sub: "план 92%",
    },
    {
        id: "meters",
        icon: Gauge,
        accent: "violet",
        label: "Передано показаний",
        value: "3 412",
        delta: "+204",
        deltaDir: "up",
        sub: "из 5 870 · 58%",
    },
];

export const PRIORITY_TICKETS: PriorityTicket[] = [
    {
        id: "Т-4471",
        title: "Течь стояка ХВС",
        subTitle: "Аварийная",
        icon: Droplet,
        iconBg: "#e0f2fe",
        iconFg: "#0ea5e9",
        addr: "Берёзовая, 14 · кв. 56",
        assignee: "А. Громов",
        sla: "−2 ч",
        slaTone: "danger",
        status: "В работе",
        statusTone: "info",
    },
    {
        id: "Т-4470",
        title: "Отказ лифта №2",
        subTitle: "Аварийная",
        icon: ArrowUpDown,
        iconBg: "#fee2e2",
        iconFg: "#ef4444",
        addr: "Парковая, 7к1",
        assignee: "Лифт-СТО",
        sla: "0:42",
        slaTone: "warning",
        status: "Назначена",
        statusTone: "violet",
    },
    {
        id: "Т-4468",
        title: "Нет горячей воды по стояку",
        subTitle: "Жалоба",
        icon: Flame,
        iconBg: "#fef3c7",
        iconFg: "#f59e0b",
        addr: "Парковая, 7к1 · подъезд 3",
        assignee: "М. Иванов",
        sla: "1:08",
        slaTone: "warning",
        status: "Диагностика",
        statusTone: "info",
    },
    {
        id: "Т-4465",
        title: "Шум в подвале",
        subTitle: "Стандарт",
        icon: Zap,
        iconBg: "#fef3c7",
        iconFg: "#f59e0b",
        addr: "Берёзовая, 14",
        assignee: "—",
        sla: "3:21",
        slaTone: "warning",
        status: "Новая",
        statusTone: "",
    },
    {
        id: "Т-4462",
        title: "Замена дверного доводчика",
        subTitle: "Плановая",
        icon: Wrench,
        iconBg: "#d1fae5",
        iconFg: "#047857",
        addr: "Лесная, 2",
        assignee: "А. Громов",
        sla: "сегодня",
        slaTone: "info",
        status: "В работе",
        statusTone: "info",
    },
    {
        id: "Т-4459",
        title: "Уборка после ремонта на 4 эт.",
        subTitle: "Плановая",
        icon: Brush,
        iconBg: "#d1fae5",
        iconFg: "#047857",
        addr: "Берёзовая, 14 · подъезд 1",
        assignee: "Клин-Сервис",
        sla: "завтра",
        slaTone: "info",
        status: "Запланирована",
        statusTone: "",
    },
];

export const COLLECTIONS: CollectionsData = {
    plan: 92,
    actualPct: 91.4,
    accrued: "14.2 млн ₽",
    received: "12.99 млн ₽",
    debt: "1.21 млн ₽",
    trend: [60, 64, 71, 73, 78, 82, 85, 88, 91],
};

export const TOP_BUILDINGS: TopBuilding[] = [
    {addr: "Берёзовая, 14", count: 38, max: 38, tone: "#ef4444"},
    {addr: "Парковая, 7к1", count: 27, max: 38, tone: "#f59e0b"},
    {addr: "Лесная, 2", count: 18, max: 38, tone: "#10b981"},
    {addr: "Солнечный, 11", count: 12, max: 38, tone: "#10b981"},
    {addr: "Берёзовая, 16", count: 9, max: 38, tone: "#10b981"},
];

export const ACTIVITY_EVENTS: ActivityEvent[] = [
    {
        time: "11:42",
        icon: CheckCircle2,
        iconFg: "#047857",
        textParts: [
            {text: "Заявка "},
            {text: "Т-4458", bold: true},
            {text: " закрыта · "},
            {text: "Светильник в подъезде, Лесная 2", muted: true},
        ],
    },
    {
        time: "11:31",
        icon: Send,
        iconFg: "#0ea5e9",
        textParts: [
            {text: "Жилец "},
            {text: "Е. Соколова", bold: true},
            {text: " подтвердил оплату 4 320 ₽ · "},
            {text: "Содержание · апрель", muted: true},
        ],
    },
    {
        time: "10:58",
        icon: AlertTriangle,
        iconFg: "#ef4444",
        textParts: [
            {text: "Авария "},
            {text: "Т-4471", bold: true},
            {text: " · течь стояка ХВС на Берёзовой 14 · назначена бригада"},
        ],
    },
    {
        time: "10:02",
        icon: Vote,
        iconFg: "#7c3aed",
        textParts: [
            {text: "Голосование "},
            {text: "«Шлагбаум во дворе»", bold: true},
            {text: " · 142 голоса · кворум 67%"},
        ],
    },
    {
        time: "09:14",
        icon: Gauge,
        iconFg: "#7c3aed",
        textParts: [
            {text: "Передано 84 показания счётчиков · ИПУ электричество"},
        ],
    },
];

export const ACTIVE_VOTES: ActiveVote[] = [
    {
        title: "Установка шлагбаума во дворе",
        quorum: 67,
        goal: 50,
        votes: "142 / 212",
        tone: "#10b981",
    },
    {
        title: "Замена входных групп в подъездах",
        quorum: 38,
        goal: 50,
        votes: "81 / 212",
        tone: "#f59e0b",
    },
    {
        title: "Тариф на содержание с 1 июля",
        quorum: 22,
        goal: 50,
        votes: "47 / 212",
        tone: "#ef4444",
    },
];
